import { HStack, Icon, VStack } from "@chakra-ui/react";
import { LuChevronRight } from "react-icons/lu";
import CDS, { ActionTypeTag } from "design-system";
import { templatePathByTemplateOrSummary } from "helpers/url/pages/v2/actionPaths";
import { useNavigate } from "react-router";
import { ALL_TEMPLATE_TYPES } from "features/Resources/Shared/constants";
import { ActionType, TemplateType } from "features/Resources/Shared/models";
import { PathId } from "features/Path/models";

const TEMPLATE_LABEL: Record<TemplateType, string> = {
  email_template: "Email",
  message_template: "Message",
  task_template: "Task",
  meeting_template: "Meeting",
  checkpoint_template: "Checkpoint",
};

function TemplateRow({ templateType, pathId }: { templateType: TemplateType; pathId: PathId }) {
  const navigate = useNavigate();
  const actionType = templateType.replace(/_template$/, "") as ActionType;
  const newTemplateUrl = templatePathByTemplateOrSummary({ templateType, template: { id: "new" } });

  return (
    <HStack
      w="full"
      px={4}
      py={3}
      spacing={3}
      cursor="pointer"
      borderRadius="md"
      _hover={{ bg: "gray.50" }}
      onClick={() => navigate(`${newTemplateUrl}?newPathId=${pathId}`)}
    >
      <ActionTypeTag.IconBadgeWithMeetingType actionType={actionType} size="sm" />
      <CDS.Text12 fontWeight="medium" color="gray.800" flex={1}>
        {TEMPLATE_LABEL[templateType]}
      </CDS.Text12>
      <Icon as={LuChevronRight} boxSize={4} color="gray.400" />
    </HStack>
  );
}

export default function NewTemplateForm({ pathId }: { pathId: PathId }) {
  return (
    <VStack spacing={0} align="stretch">
      {ALL_TEMPLATE_TYPES.map((templateType: TemplateType) => (
        <TemplateRow key={templateType} templateType={templateType} pathId={pathId} />
      ))}
    </VStack>
  );
}
